import { useMutation } from '@tanstack/react-query';

import { apiClient } from 'core/api/globals';

/**
 * Hook for downloading a file from the upload tracker.
 * @returns Mutation for downloading a file.
 */
export function useMutationDownloadUploadTrackerFile() {
  return useMutation({
    mutationFn: async ({ studyInstanceUID, requestUID, source }: { studyInstanceUID?: string; requestUID?: string; source?: string }) => {
      let downloadBlob: Blob;

      if (studyInstanceUID) {
        downloadBlob = await apiClient.uploadTrackerClient.downloadFile(studyInstanceUID);
        return { blob: downloadBlob, filename: studyInstanceUID, type: 'zip' };
      } else if (source === 'Web-Alternative') {
        if (requestUID == null) throw new Error('Parameter requestUID is required for Web-Alternative source download.');

        downloadBlob = await apiClient.uploadTrackerClient.downloadUploadSessionZip(requestUID);
        return { blob: downloadBlob, filename: `Upload ${requestUID}`, type: 'zip' };
      }

      throw new Error('Invalid parameters for download.');
    },
  });
}
